/** Rubrique Hors-ligne et synchro : état réseau réel, dernière sync, file d'attente. */
import { Wifi, WifiOff, RefreshCw, CheckCircle2 } from 'lucide-react';
import { Button, Card } from '../../../components/ui/kit';
import { useOffline } from '../../../context/OfflineContext';

export default function HorsLigne() {
  const { online, pending, syncing, lastSync, syncNow } = useOffline() || {};
  const time = lastSync ? new Date(lastSync).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—';

  return (
    <div className="max-w-[560px]">
      <h2 className="font-title text-3xl mb-2">Hors-ligne et synchro</h2>
      <p className="text-[13px] text-n600 mb-5">
        La cave n'a pas toujours de réseau. L'application reste utilisable hors-ligne (consultation,
        sortie, inventaire) et synchronise automatiquement au retour du réseau.
      </p>
      <Card className="p-5 space-y-3" data-testid="offline-panel">
        <div className="flex items-center gap-2">
          {online ? <Wifi className="w-4 h-4 text-gold700" /> : <WifiOff className="w-4 h-4 text-n600" />}
          <span className="text-[14px]" data-testid="offline-state">État : {online ? 'En ligne' : 'Hors ligne'}</span>
        </div>
        <p className="text-[13px] text-n600 flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-gold700" /> Dernière synchronisation : {time}
        </p>
        <p className="text-[13px] text-n600" data-testid="offline-pending">
          File d'attente : {pending || 0} mouvement(s) en attente
        </p>
        <p className="text-[13px] text-n600">Données mises en cache : catalogue, emplacements, prix de vente</p>
        <Button variant="secondary" onClick={syncNow} disabled={!online || syncing} data-testid="sync-now">
          <RefreshCw className={`w-4 h-4 ${syncing ? 'animate-spin' : ''}`} />
          {syncing ? 'Synchronisation…' : 'Synchroniser maintenant'}
        </Button>
      </Card>
    </div>
  );
}
